
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crops",
      function () {
        return require("private-next-pages/crops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crops"])
      });
    }
  